<template>
  <div class="card-recently-bought">
    <figure class="card-recently-bought__image">
      <img
        :alt="`${reviewData.product_name}-${reviewData.manufacturer_name}`"
        :src="mainImage(reviewData.image)"
        src-placeholder="/assets/img/dummy_product.svg"
      />
    </figure>
    <div class="card-recently-bought__info">
      <div>
        <div>
          <h4 class="brand">{{ reviewData.manufacturer_name | trimName }}</h4>
          <h3 class="name">{{ reviewData.product_name }}</h3>
        </div>
        <template v-if="!dashboard">
          <img
            v-if="user.is_expert_reviewer"
            src="/assets/img/expert-review-check-icon.svg"
            height="18"
            width="18"
            alt="icon-expert"
            class="icon-shop-expert"
          />
          <img
            v-else-if="isShopperReview"
            src="/assets/img/icon-shopper.svg"
            height="18"
            width="18"
            alt="shopper"
            class="icon-shop-expert"
          />
        </template>
      </div>
      <div class="footer-wrapper" :class="{ inline: inlineFooter }">
        <GRatingInline
          v-if="isShowRating"
          :average-rating="reviewAverageRating"
          :inline-reviewers="reviewData.review_stats.total_reviews"
          :star-fill-number="reviewStarFillNumber"
          :total-stars="1"
        />
        <div v-else class="rating--uniform timeline-review">
          <div class="rate-star--uniform rate-star--uniform-0">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="card-recently-bought__review">
          <a href="javascript:void(0)" @click.prevent="selectProduct(reviewData)">Write review</a>
          <!-- <router-link :to="`review/add/${reviewData.id}`">Write Review</router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CardRecentlyBought',
  props: {
    reviewData: {
      type: Object,
      required: true,
    },
    inlineFooter: {
      type: Boolean,
      default: () => false,
    },
    isShowRating: {
      type: Boolean,
      default: () => false,
    },
    dashboard: {
      type: Boolean,
      default: () => false,
    },
    isTrending: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isShopperReview() {
      return this.reviewData.combinations.some((combination) => combination.is_verified_purchase);
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    reviewAverageRating() {
      if (!this.hideAverageRating && this.reviewData.review_stats) {
        return this.$options.filters.rating(this.reviewData.review_stats.average_rating);
      }
      return null;
    },
    reviewStarFillNumber() {
      if (this.reviewData.review_stats) {
        return this.$options.filters.rating(this.reviewData.review_stats.average_rating) * 10;
      } else {
        return 0;
      }
    },
  },
  methods: {
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=72' : 'w=62',
        image: src,
      });
    },
    convertName(title) {
      if (!title) {
        return '';
      }
      let name = title;
      const word_length = 30;

      if (name.toString().length >= word_length) {
        name = name.toString().substr(0, word_length) + '...';
      }
      return name;
    },
    selectProduct(product) {
      if (this.isTrending) {
        this.$router
          .push({
            path: `/review/add/${product['id']}`,
          })
          .catch((err) => {});
      } else {
        this.$router
          .push({
            path: `/review/add/${product['id']}`,
            query: { ...this.$route.query, combination_id: product.default_combination._id },
          })
          .catch((err) => {});
      }

      this.$store.dispatch('setDataSelectedProduct', {
        dataSelectedProduct: product,
        component: this,
      });
      this.$store.commit('setAddReviewSource', 'dashboard');
      this.$emit('write-review-clicked');
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'card-recently-bought';
</style>
